export default {"src":"/app/_next/static/media/sleeping-cat.2d81c654.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};